import { render, staticRenderFns } from "./medication.vue?vue&type=template&id=7d67ece2&scoped=true&"
import script from "./medication.vue?vue&type=script&lang=js&"
export * from "./medication.vue?vue&type=script&lang=js&"
import style0 from "./medication.vue?vue&type=style&index=0&id=7d67ece2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d67ece2",
  null
  
)

export default component.exports